import { fg } from '@atlaskit/platform-feature-flags';

// Query page size for navigation items
export const DEFAULT_PAGE_SIZE = 20;
export const LARGE_PAGE_SIZE = 100;

export default {
	get(): number {
		return fg('navx-3133-bump-page-size-for-platform-navigation')
			? LARGE_PAGE_SIZE
			: DEFAULT_PAGE_SIZE;
	},
};
